import billing from '@/api/billing';

import {
    GET_TARIFF_LIST_BEGIN,
    GET_TARIFF_LIST_SUCCESS,
    GET_TARIFF_LIST_FAILURE,
    CREATE_TARIFF_BEGIN,
    CREATE_TARIFF_SUCCESS,
    CREATE_TARIFF_FAILURE,
    UPDATE_TARIFF_BEGIN,
    UPDATE_TARIFF_SUCCESS,
    UPDATE_TARIFF_FAILURE,
    DELETE_TARIFF_BEGIN,
    DELETE_TARIFF_SUCCESS,
    DELETE_TARIFF_FAILURE,
    GET_TRANSACTION_LIST_BEGIN,
    GET_TRANSACTION_LIST_SUCCESS,
    GET_TRANSACTION_LIST_FAILURE,
    GET_INVOICE_LIST_BEGIN,
    GET_INVOICE_LIST_SUCCESS,
    GET_INVOICE_LIST_FAILURE,
} from './types';

const initialState = {
    tariffList: false,
    tariffListError: false,
    tariffError: false,
    transactionList: false,
    transactionListError: false,
    invoiceList: false,
    invoiceListError: false,
};

const getters = {
    tariffList: (state) => state.tariffList,
    tariffListError: (state) => state.tariffListError,
    tariffError: (state) => state.tariffError,
    transactionList: (state) => state.transactionList,
    transactionListError: (state) => state.transactionListError,
    invoiceList: (state) => state.invoiceList,
    invoiceListError: (state) => state.invoiceListError,
};

const actions = {
    getTariffList({ commit }, filter) {
        commit(GET_TARIFF_LIST_BEGIN);
        return billing.getTariffList(filter)
            .then((response) => commit(GET_TARIFF_LIST_SUCCESS, response.data))
            .catch((error) => commit(GET_TARIFF_LIST_FAILURE, error.response?.data || error));
    },
    createTariff({ commit }, data) {
        commit(CREATE_TARIFF_BEGIN);
        return billing.createTariff(data)
            .then(() => commit(CREATE_TARIFF_SUCCESS))
            .catch((error) => commit(CREATE_TARIFF_FAILURE, error.response?.data || error));
    },
    updateTariff({ commit }, { id, data }) {
        commit(UPDATE_TARIFF_BEGIN);
        return billing.updateTariff(id, data)
            .then(() => commit(UPDATE_TARIFF_SUCCESS))
            .catch((error) => commit(UPDATE_TARIFF_FAILURE, error.response?.data || error));
    },
    deleteTariff({ commit }, id) {
        commit(DELETE_TARIFF_BEGIN);
        return billing.deleteTariff(id)
            .then(() => commit(DELETE_TARIFF_SUCCESS))
            .catch((error) => commit(DELETE_TARIFF_FAILURE, error.response?.data || error));
    },
    getTransactionList({ commit }, filter) {
        commit(GET_TRANSACTION_LIST_BEGIN);
        return billing.getTransactionList(filter)
            .then((response) => commit(GET_TRANSACTION_LIST_SUCCESS, response.data))
            .catch((error) => commit(GET_TRANSACTION_LIST_FAILURE, error.response?.data || error));
    },
    getInvoiceList({ commit }, filter) {
        commit(GET_INVOICE_LIST_BEGIN);
        return billing.getInvoiceList(filter)
            .then((response) => commit(GET_INVOICE_LIST_SUCCESS, response.data))
            .catch((error) => commit(GET_INVOICE_LIST_FAILURE, error.response?.data || error));
    },
};

const mutations = {
    [GET_TARIFF_LIST_BEGIN](state) {
        state.tariffListError = false;
    },
    [GET_TARIFF_LIST_SUCCESS](state, data) {
        state.tariffList = data;
    },
    [GET_TARIFF_LIST_FAILURE](state, error) {
        state.tariffListError = error;
    },
    [CREATE_TARIFF_BEGIN](state) {
        state.tariffError = false;
    },
    [CREATE_TARIFF_SUCCESS]() {},
    [CREATE_TARIFF_FAILURE](state, error) {
        state.tariffError = error;
    },
    [UPDATE_TARIFF_BEGIN](state) {
        state.tariffError = false;
    },
    [UPDATE_TARIFF_SUCCESS]() {},
    [UPDATE_TARIFF_FAILURE](state, error) {
        state.tariffError = error;
    },
    [DELETE_TARIFF_BEGIN](state) {
        state.tariffError = false;
    },
    [DELETE_TARIFF_SUCCESS]() {},
    [DELETE_TARIFF_FAILURE](state, error) {
        state.tariffError = error;
    },
    [GET_TRANSACTION_LIST_BEGIN](state) {
        state.transactionListError = false;
    },
    [GET_TRANSACTION_LIST_SUCCESS](state, data) {
        state.transactionList = data;
    },
    [GET_TRANSACTION_LIST_FAILURE](state, error) {
        state.transactionListError = error;
    },
    [GET_INVOICE_LIST_BEGIN](state) {
        state.invoiceListError = false;
    },
    [GET_INVOICE_LIST_SUCCESS](state, data) {
        state.invoiceList = data;
    },
    [GET_INVOICE_LIST_FAILURE](state, error) {
        state.invoiceListError = error;
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations,
};
